import { TOGGLE_DRAWER } from '../helpers/constants';

export const toggleDrawer = (open: boolean) => {
    return { type: TOGGLE_DRAWER, payload: open };
};
